import React, { useContext, useEffect } from 'react';
import { io } from 'socket.io-client';
import { getParentId, getUserId } from './client';
import { isAgent } from './util';

export const SocketConnectionContext = React.createContext();

export const SocketConnectionProvider = ({ children }) => {
  const socketNameSpace = isAgent() ? getParentId() : getUserId();

  const socket = io(`${process.env.REACT_APP_CHATBOT_URL}/${socketNameSpace}`, {
    transports: ['websocket', 'polling'],
    withCredentials: true,
    query: {
      user_id: getUserId(),
    },
  });
  const defaultNamespaceSocket = io(`${process.env.REACT_APP_CHATBOT_URL}`, {
    transports: ['websocket', 'polling'],
    query: {
      user_id: getUserId(),
      parent_id: socketNameSpace,
    },
  });

  const messageStatusSocket = io(
    `${process.env.REACT_APP_MESSAGE_STATUS_URL}`,
    {
      transports: ['websocket', 'polling'],
      withCredentials: false,
    }
  );
  socket.on('connect_error', (err) => {
    console.log({ err });
  });

  useEffect(() => {
    return () => {
      socket.disconnect();
      defaultNamespaceSocket.disconnect();
      messageStatusSocket.disconnect();
    };
  }, []);

  return (
    <SocketConnectionContext.Provider
      value={{
        socket,
        messageStatusSocket,
      }}
    >
      {children}
    </SocketConnectionContext.Provider>
  );
};

export const socketConnectionContext = () =>
  useContext(SocketConnectionContext);
